export const LOAD_THEME = "@theme.LOAD_THEME";
export const SET_THEME = "@theme.SET_THEME";